const Footer = () => {
  return (
    <div className="footer">
      <p className="footer-text">&copy; FoodWebsite by @yacine-ahmed-adel</p>
    </div>
  );
};

export default Footer;
